export default {
    //Constantes de estados de la Orden
    c_Estatus_Anulacion: 'A',
    c_Estatus_Operador: 'O',
    c_Estatus_Despachada: 'D',
    c_Estatus_Facturada: 'F',
    c_Estatus_Ruta: 'R',
    c_Estatus_Borrada: 'B',
    c_Estatus_Terminada: 'T',
    c_Estatus_Espera: 'E',
    c_Estatus_Pospuesta: 'P',
    c_Estatus_Modificando: 'M',
    c_Estatus_Venta: 'V',
    c_Estatus_Impresa: 'I',
    c_Estatus_Aseguradora: 'G',
    c_Estatus_Remesa: 'S',


    /*constantes de opciones de menu*/
    // Liquidar Orden
    m_LiquidarOrdenes: 1,
    // Monitor Sucursal
    m_Eliminar_Orden: 1,
    m_Despachar_Orden: 2,
    m_Imprimir_Orden: 3,
    m_Despachar_Lotes_Vencidos: 4,
    // Asignar Orden Repartidor
    m_Asignar_Orden_Repartidor_Ruta: 1,
    m_Pasar_A_Ruta: 2,
    m_Finalizar_Ruta: 3,
    m_Eliminar_Orden_Asignada: 4
};